import type { SelectProjectsResponse } from 'hooks/api/general/useGetSelectProjects';
import { TECH_PROJECT_NAME } from 'hooks/permission/constants';

import type { NOTIFICATION_LEVELS_NAMES } from 'pages/notifications/constants';
import { NEW_NOTIFICATION_EVENT_NAME, NO_NOTIFICATION_ID, notificationColors } from 'pages/notifications/constants';

import type { ChipProps } from '@mui/material';

export const checkNewNotification = async (response: Response): Promise<void> => {
    const newNotificationId = response.headers.get('New-Notifications');

    if (!newNotificationId) {
        const event = new CustomEvent(NEW_NOTIFICATION_EVENT_NAME, { detail: { notificationId: NO_NOTIFICATION_ID } });
        window.dispatchEvent(event);
        localStorage.setItem('notificationId', NO_NOTIFICATION_ID);
        return;
    }

    const storedNotificationId = localStorage.getItem('notificationId');

    if (storedNotificationId === newNotificationId) {
        return;
    }

    localStorage.setItem('notificationId', newNotificationId);

    const event = new CustomEvent(NEW_NOTIFICATION_EVENT_NAME, { detail: { notificationId: newNotificationId } });
    window.dispatchEvent(event);

    return Promise.resolve();
};

export const getNameFromEmail = (email: string): string => {
    const [namePart] = email.split('@');
    const [firstName, lastName] = namePart.split('.');

    return `${firstName} ${lastName}`;
};

export const getNotificationColorDependingOnType = (value: keyof typeof NOTIFICATION_LEVELS_NAMES): ChipProps['color'] => {
    return notificationColors[value];
};

export const getTechProjectId = (projects: SelectProjectsResponse[]) => {
    return projects.find((project) => project.system_name === TECH_PROJECT_NAME)?.id ?? 0;
};
